import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.page.html',
  styleUrls: ['./resetpassword.page.scss'],
})
export class ResetpasswordPage implements OnInit {
  isLoading: boolean = false;
  dataForm: FormGroup;
  @Input() user: any;
  constructor(public modalController: ModalController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'otp': new FormControl(null, [Validators.required]),
      'password': new FormControl(null, [Validators.required]),
      'repassword': new FormControl(null, [Validators.required]),
      'forgot_password_code': new FormControl(this.user.forgot_password_code, [])
    }, this.pwdMatchValidator);
  }

  pwdMatchValidator(frm: FormGroup) {
    return frm.get('password').value === frm.get('repassword').value
      ? null : { 'mismatch': true };
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  resetPassword() {
    this.isLoading = true;
    this.restApi.resetPassword(this.dataForm.value).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        this.closeDialog();
      }
      this.commonFunctions.presentAlertConfirm('Information', data['message']);
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

}
